

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const IntellectualPropertySection = () => {
  return (
    <div>
      <Paragraph>
        TrackBiz and all related software, source code, designs, documentation,
        templates, workflows, user interfaces, trademarks, service marks, trade
        names, and other materials are and will remain the exclusive property of
        Club Sports Solutions L.L.C. or its licensors.
      </Paragraph>

      <Paragraph>
        This Agreement grants Customer a limited, non-exclusive, non-transferable,
        revocable right to access and use TrackBiz during the term of this
        Agreement solely for Customer's internal business operations.
      </Paragraph>

      <Alert
        message="No Ownership Transfer"
        description="Customer does not receive ownership of TrackBiz, its source code, platform design, software architecture, templates, documentation, trademarks, or related intellectual property."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        <Text strong>Provider-owned materials include, but are not limited to:</Text>
      </Paragraph>

      <ul>
        <li>TrackBiz software and platform functionality</li>
        <li>Source code, APIs, backend services, and databases</li>
        <li>User interface designs, layouts, templates, and workflows</li>
        <li>Documentation, training materials, and support materials</li>
        <li>Reports, dashboards, and standard platform configurations</li>
        <li>Business website templates and website framework components</li>
        <li>TrackBiz names, logos, trademarks, and branding elements</li>
      </ul>

      <Paragraph>
        Customer retains ownership of its own business name, logos, trademarks,
        photographs, product images, website content, business descriptions,
        customer information, inventory records, and other materials provided by
        Customer for use within TrackBiz or Customer's website.
      </Paragraph>

      <Alert
        message="Customer-Owned Content"
        description="Customer keeps ownership of the business content, logos, photos, product images, and other materials Customer provides to Provider."
        type="success"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer may not copy, modify, reverse engineer, decompile, disassemble,
        resell, sublicense, distribute, or create derivative works based on
        TrackBiz or any Provider-owned materials except as expressly permitted by
        this Agreement or authorized in writing by Provider.
      </Paragraph>

      <Paragraph>
        Feedback, suggestions, ideas, or recommendations provided by Customer
        regarding TrackBiz may be used by Provider to improve the platform without
        creating any compensation, ownership, or approval obligation to Customer.
      </Paragraph>
    </div>
  );
};

export default IntellectualPropertySection;